import styled from '@emotion/styled';
import { css } from '@emotion/react';
import MobileSearchBox from './MobileSearchBox';

const open = css`
  width: 10em;
  background: white;
  cursor: text;
  margin-left: -1.25em;
  padding-left: 1.6em;
`

const closed = css`
  width: 0;
  background: transparent;
  cursor: pointer;
  margin-left: -1em;
  padding-left: 1em;
`

const icon = css`
  > svg {
    width: 15px;
  }
  > svg > path {
    fill: #134053;
  }
`
const BigIcon = css`
    &:hover > svg > path {
    fill: #FCBA04;
  }
`

export default styled(MobileSearchBox)`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  margin-bottom: 0;
  justify-content: center;
  /* ${({ hasFocus }) => (
    hasFocus ? icon : BigIcon
  )} */

  .SearchInput {
    outline: none;
    font-size: 1.25em;
    transition: 100ms;
    border-radius: 4px;
    color: black;
    ::placeholder {
      color: ${({ theme }) => theme.faded};
    }
    /* ${({ hasFocus }) => (hasFocus ? open : closed)} */
  }

  .SearchIcon {
    fill: white;
    margin-right: 0.3em;
    //fill: ${({ hasFocus }) => (hasFocus ? "red" : "blue")}
    pointer-events: none;
  }
`